const BREAK_POINT = 960;
export default BREAK_POINT;
